import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, ArrowLeft, Settings, Shield, Mic, Send } from 'lucide-react';

const Navigation = ({ showBack = false, onLogout, user }) => {
  const navigate = useNavigate();

  return (
    <nav className='bg-white border-b shadow-sm'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between items-center h-16'>
          <div className='flex items-center space-x-4'>
            {showBack && (
              <Button 
                variant='ghost' 
                size='icon' 
                onClick={() => navigate('/dashboard')} 
                data-testid='back-to-dashboard-btn'
              >
                <ArrowLeft className='w-5 h-5' />
              </Button>
            )}
            <div className='flex items-center space-x-2 cursor-pointer' onClick={() => navigate('/dashboard')}>
              <img 
                src='https://customer-assets.emergentagent.com/job_smart-money-route/artifacts/6teoyzj7_Generated%20Image%20November%2018%2C%202025%20-%203_06PM.png' 
                alt='RouteFlow AI' 
                className='h-10 w-auto'
              />
            </div>
          </div>
          <div className='flex items-center space-x-2'>
            {user && (
              <>
                <Button 
                  variant='default'
                  size='sm'
                  onClick={() => navigate('/send-money')}
                  className='bg-emerald-600 hover:bg-emerald-700'
                  data-testid='send-money-btn'
                >
                  <Send className='w-4 h-4 mr-2' /> Send Money
                </Button>
                <Button 
                  variant='ghost' 
                  size='sm'
                  onClick={() => navigate('/voice-assistant')}
                  data-testid='voice-assistant-btn'
                >
                  <Mic className='w-4 h-4 mr-2' /> Voice
                </Button>
                <Button 
                  variant='ghost' 
                  size='sm'
                  onClick={() => navigate('/kyc')}
                  data-testid='kyc-btn'
                >
                  <Shield className='w-4 h-4 mr-2' /> Verify
                </Button>
                <Button 
                  variant='ghost' 
                  size='sm'
                  onClick={() => navigate('/settings')}
                  data-testid='settings-btn'
                >
                  <Settings className='w-4 h-4' />
                </Button>
              </>
            )}
            {onLogout && (
              <Button variant='ghost' size='sm' onClick={onLogout} data-testid='logout-btn'>
                <LogOut className='w-4 h-4' />
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;